import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import api from '../../api';
import { loadGlobals, loginUser } from '../../actions/index';

function SimulateLogin() {
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        localStorage.setItem('jwt_token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJcL3VzZXJcL3JlZGlyZWN0LXRvLWFwcDMiLCJpYXQiOjE3ODM4MzkwNDgsImV4cCI6MTc4Mzg0MjY0OCwibmJmIjoxNzgzODM5MDQ4LCJqdGkiOiIyOWYxYWRiM2FkMzM0Y2ZmZDMxZTkyYmQiLCJzdWIiOjE0ODV9.UPQgYadyMTBKlGL00HxHsgo2MqOmn5rum1yFoySQ5Gs');
        //localStorage.setItem('zofapp_mode', 'LECTURE');
        localStorage.setItem('zofapp_mode', 'NUTRIKUCHAR');
        localStorage.setItem('zofapp_lang', 'cs');
        //localStorage.setItem('zofapp_mode_data', '6956');
        localStorage.setItem('zofapp_mode_data', '7721');   // jidelnicek
        localStorage.setItem('zofapp_mode_data', '7607');   // recept
        localStorage.removeItem('is_admin');

        api('check-token').then(result => {
            if (result.data.valid === 0) {
                history.push('/login');
                return;
            }
            api('load/startup-data').then(result => {
                dispatch(loadGlobals(result.data));
                dispatch(loginUser({
                    user: result.data.user,
                    callback: () => history.push('/')
                }));
            });
        });
    }, []);

    return null;
}

export default SimulateLogin;
